// Strip.js
import React from "react";

export default function Strip() {
  return (
    <div className="container-fluid bg-light py-3">
      <div className="row text-center">
        <div className="col-6 col-md-3 mb-2">
          <h4 className="fw-bold" style={{ color: "#8B151B" }}>75,000+</h4>
          <p className="mb-0">Happy Customers</p>
        </div>
        <div className="col-6 col-md-3 mb-2">
          <h4 className="fw-bold" style={{ color: "#8B151B" }}>₹44,000+ Cr.</h4>
          <p className="mb-0">Loans Disbursed</p>
        </div>
        <div className="col-6 col-md-3 mb-2">
          <h4 className="fw-bold" style={{ color: "#8B151B" }}>7500+</h4>
          <p className="mb-0">Pin Codes Covered</p>
        </div>
        <div className="col-6 col-md-3 mb-2">
          <h4 className="fw-bold" style={{ color: "#8B151B" }}>₹20,399 Cr.</h4>
          <p className="mb-0">AUM as of June 30, 2024</p>
        </div>
      </div>
    </div>
  );
}
